import { Apollo_gql, GraphMutationPayload } from '@ta/server';

import { notificationProps } from './dto/notification';

export function markNotificationAsRead(notificationId: string): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation MarkNotificationAsRead($notificationId: UUID!) {
        markNotificationAsRead(notificationId: $notificationId) {
          ${notificationProps.get('id')}
          ${notificationProps.get('isRead')}
        }
      }
    `,
    variables: { notificationId },
  };
}

export function markAllNotificationsAsRead(): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation MarkAllNotificationsAsRead {
        markAllNotificationsAsRead
      }
    `,
    variables: {},
  };
}

export function deleteNotification(notificationId: string): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation DeleteNotification($notificationId: UUID!) {
        deleteNotification(notificationId: $notificationId) {
          ${notificationProps.get('id')}
        }
      }
    `,
    variables: { notificationId },
  };
}
